<template>
  <div>
    <div style="margin-top: 15%;">
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :xl="6" :lg="7">
          <h1 style="color: var(--brand-primary)">销售人员诚信心理测试</h1>
          <el-image :src="require('@/assets/xinliLogo.png')" style="height: 160px; width: 355px;"></el-image>
        </el-col>

        <el-col :span="1">
          <el-divider direction="vertical"></el-divider>
        </el-col>
        <el-col :xl="6" :lg="7">
          <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="80px" style="margin-top: 50px">
            <el-form-item label="用户名" prop="username" style="width: 380px;">
              <el-input v-model="loginForm.username"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" style="width: 380px;">
              <el-input v-model="loginForm.password" type="password"></el-input>
            </el-form-item>

            <el-form-item>
              <div style="display: flex">
                <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
                <el-button style="margin-left: 40px" @click="resetForm('loginForm')">重置</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 50px; text-align: center">
      <el-link href="https://beian.miit.gov.cn" target="_blank">工业和信息化部备案管理系统网站 沪ICP备16034788号-4</el-link>
      <div style="color: #686767;">上海心梨信息科技有限公司</div>
    </div>
  </div>
</template>

<script>
import qs from "qs";

export default {
  name: "Login",

  data() {
    return {
      loginForm: {
        username: "",
        password: "",

      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      captchaImg: null
    };
  },

  created() {
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const payload = { username: this.loginForm.username, password: this.loginForm.password }
          this.$axios
            .post("/api/login?" + qs.stringify(payload))
            .then(res => {
              if (res.data.code !== 200) {
              } else {
                const jwt = res.headers["token"];
                this.$store.commit("setToken", jwt);
                this.$store.commit("setUserId", res.data.data.userId);
                this.$store.commit("setUsername", res.data.data.username);
                const u = String(res.data.data.username || this.loginForm.username || '').trim();
                if (/_hr$/i.test(u) || /人力资源/i.test(u)) {
                  this.$router.push("/hr/measure-result");
                } else {
                  this.$router.push("/index");
                }
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },


  }
};
</script>

<style scoped>
.el-row {
  background: linear-gradient(180deg, var(--bg-soft) 0%, #ffffff 100%);
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.el-divider {
  margin-top: 40px;
  height: 240px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue